import React, { useState } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import './VideoGrid.css';

const VideoGrid = () => {
  const { t } = useTranslation();
  const raw = t('videos.items');
  const items = Array.isArray(raw) ? raw : [];

  if (items.length === 0) return null;

  return (
    <section className="section video-grid-section">
      <div className="container">
        <h2 className="section-title" style={{ textAlign: 'center' }}>
          {t('videos.title')}
        </h2>
        <p className="section-subtitle" style={{ textAlign: 'center', margin: '0 auto 48px' }}>
          {t('videos.subtitle')}
        </p>
        <div className="video-grid">
          {items.map((item, index) => (
            <VideoCard key={index} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

const VideoCard = ({ item }) => {
  const [playing, setPlaying] = useState(false);

  const thumbnailUrl = `https://img.youtube.com/vi/${item.id}/hqdefault.jpg`;

  return (
    <div className="video-grid__card">
      {!playing ? (
        <div className="video-grid__poster" onClick={() => setPlaying(true)}>
          <img
            src={thumbnailUrl}
            alt={item.title || ''}
            className="video-grid__thumb"
            loading="lazy"
          />
          <div className="video-grid__play-overlay">
            <svg viewBox="0 0 68 48" className="video-grid__play-icon">
              <path
                d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
                fill="rgba(230,57,70,0.9)"
              />
              <path d="M 45,24 27,14 27,34" fill="white" />
            </svg>
          </div>
        </div>
      ) : (
        <div className="video-grid__iframe-wrap">
          <iframe
            src={`https://www.youtube.com/embed/${item.id}?autoplay=1&rel=0`}
            title={item.title || ''}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}
      {item.title && <p className="video-grid__caption">{item.title}</p>}
    </div>
  );
};

export default VideoGrid;
